export const applicationAttributes = {
    reactions: 'reactions',
    message_search_v3: 'message_search_v3',
    enable_og_tag: 'enable_og_tag',
    enable_message_threading: 'enable_message_threading',
    allow_broadcast_channel: 'allow_broadcast_channel',
    allow_super_group_channel: 'allow_super_group_channel',
};
